import { action } from 'satcheljs';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';

export const fetchLocationDetails = action('fetchLocationDetails', (locationId: string) => ({
    locationId,
}));

export const initializePlace = action(
    'initializePlace',
    (
        name: string,
        postalAddress: PersonaPostalAddress,
        locationId: string,
        phoneNumber: string
    ) => ({
        name,
        postalAddress,
        locationId,
        phoneNumber,
    })
);

export const initializeLocationCardIfNeeded = action(
    'initializeLocationCardIfNeeded',
    (
        locationId: string,
        name?: string,
        postalAddress?: PersonaPostalAddress,
        phoneNumber?: string
    ) => ({
        locationId,
        name,
        postalAddress,
        phoneNumber,
    })
);

export const onLocationDetailsLoaded = action(
    'onLocationDetailsLoaded',
    (locationId: string, latitude: number, longitude: number) => ({
        locationId,
        latitude,
        longitude,
    })
);
